import {
  POSSIBLE_INSIDE_INFRASTRUCTURE_TYPES,
  POSSIBLE_OUTSIDE_INFRASTRUCTURE_TYPES,
} from '../../../constants/infrastructure';
import {
  EInsideTAInfrastructureType,
  EOutsideTAInfrastructureType,
  TRegularInfrastructureItem,
} from '../../../types/map';
import { hasFutureObjects } from '../../../utils/map';

export function getBlockTypeByInfrastructureType(
  infrastructureType: string | undefined,
  infrastructureItems: TRegularInfrastructureItem[],
) {
  if (POSSIBLE_OUTSIDE_INFRASTRUCTURE_TYPES.includes(infrastructureType as EOutsideTAInfrastructureType)) {
    return 'accessibility_near_jk';
  }

  if (POSSIBLE_INSIDE_INFRASTRUCTURE_TYPES.includes(infrastructureType as EInsideTAInfrastructureType)) {
    return 'accessibility_inside_jk';
  }

  if (hasFutureObjects(infrastructureItems)) {
    return 'future';
  }

  return 'standard';
}
